module.exports = __webpack_public_path__ + "img/MMs-4.25.aa9d9ba0.jpeg";